import React from "react"
import { useParams } from "react-router-dom"
import { useTranslate } from "ra-core"
import { Box } from "@mui/material"
import BarChartIcon from "@mui/icons-material/BarChart"
import TableIcon from "@mui/icons-material/TableRowsTwoTone"
import ScheduleIcon from "@mui/icons-material/Schedule"
import { useTheme } from "@mui/material/styles"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import { List, TopToolbar, CreateButton, SelectColumnsButton } from "react-admin"
import { ScheduleDataGrid } from "components/schedule"

const ScheduleList = ({id}: {id: string}) => {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "devices", icon: <ScheduleIcon/> },
        { label: translate("resources.devices.data"), name: "data", resource: "devices", icon: <TableIcon/> },
        { label: translate("resources.devices.chart"), name: "chart", resource: "devices", icon: <BarChartIcon/> },
    ]

    return (
            <Box display="flex" flexDirection="column" width="100%">
                <Box mb={1}>
                    <RecordActionsTabs subTabs={subTabs} resourceParent="devices"/>
                </Box>
                <Box display="flex" justifyContent="flex-end">
                    <TopToolbar>
                        <CreateButton resource={`devices/${id}/schedules`}/>
                        <SelectColumnsButton />
                    </TopToolbar>
                </Box>
            </Box>
        )
}

const Schedule = () => {
    const translate = useTranslate()
    const { id } = useParams<{ id: string }>()
    const theme = useTheme()

    return (
        <List
            resource={`schedules/entity/device/${id}`}
            title={translate('resources.schedules.name')}
            actions={<ScheduleList id={id!}/>}
            empty={false}
        >
            <ScheduleDataGrid resource={`/devices/${id}/schedules`} />
        </List>
    )
}

export default Schedule
